import { Paper, styled, Typography } from "@mui/material";
import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { useTranslation } from "react-i18next";
import { MeasureImpact } from "types/types";
import { MeasureItem } from "./MeasureItem";

interface Props {
  measures: MeasureImpact[];
}

export function MeasuresContainer(props: Props) {
  const { measures } = props;
  const { t } = useTranslation();
  return (
    <StyledPaddedPaper elevation={0} padding={4}>
      <Typography variant="h4" component="h2">
        {t("label.measuresWithMajorImpactOnThisProject")}
      </Typography>
      <Paper className={"measure-container"} elevation={0}>
        {measures.map((measure) => {
          return <MeasureItem measure={measure} key={measure.measure.id} />;
        })}
      </Paper>
    </StyledPaddedPaper>
  );
}

const StyledPaddedPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.grey[200]};
  gap: ${({ theme }) => theme.spacing(2)};
  max-height: 50%;
  margin-top: auto;
  .measure-container {
    gap: ${({ theme }) => theme.spacing(3)};
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    background-color: inherit;
    padding-bottom: ${({ theme }) => theme.spacing(1)};
    min-height: ${({ theme }) => theme.spacing(14)};
    height: 100%;
  }
`;
